import script from "./oasis-sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./oasis-sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./oasis-sidebar.vue?vue&type=style&index=0&id=e0d42908&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0d42908"]])

export default __exports__